<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TwWhatsappSharingButton',
  props: {
    network: {
      type: Object,
      default: () => ({
        name: 'WhatsApp',
        icon: 'fab fa-lg fa-whatsapp',
        color: '#25d366'
      })
    },
    shareOptions: {
      type: Object,
      default: () => ({
        text: 'Check out this fundraiser!',
        url: window.location.href
      })
    },
  },
  methods: {
    shareWhatsapp() {
      const { text, title, url } = this.shareOptions
      const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(title?title:text)} ${encodeURIComponent(url)}`
      window.open(whatsappUrl, '_blank')
    }
  }
})
</script>

<template>
  <div @click="shareWhatsapp">
    <slot name="default" />
  </div>
</template>

<style scoped>

</style>
